export const actions = {
  replaceOrAdd(object) {
    let exists = this.collection.find(c => c.id === object.id);
    if (exists) {
      let index = this.collection.indexOf(exists);
      this.collection[index] = object;
      return this.replaceActionLabel;
    } else {
      this.collection.push(object);
      return this.addActionLabel;
    }
  },
  removeById(objectId) {
    let exists = this.collection.find(c => c.id === objectId);
    if (exists) {
      let index = this.collection.indexOf(exists);
      this.collection.splice(index, 1);
    }
  },
};

export const state = () => {
  return {
    collection: [],
    addActionLabel: 'added',
    replaceActionLabel: 'replaced',
  };
};

export const getters = {
  getById: (state) => {
    return (objectId) => state.collection.find(c => c.id === objectId);
  },
}
